








































import { Component, Vue, Prop } from "vue-property-decorator";
import { FormFieldProps, FormFieldRules, IFormField } from "../../../Models/Components.model";
import { Auth0UserDTO } from "../../../Generated/ParticaAPI";
import ButtonList from "../../Common/Buttons/ButtonList.vue";
import ParticaBaseForm from "../../Base/ParticaBaseForm.vue";

@Component(
	{
		name: "CreateSubscriber",
		components: { ButtonList }
	})
export default class CreateSubscriber extends ParticaBaseForm<Auth0UserDTO> {

	@Prop({ default: [] }) private connections: string[];

	private domainIdconfig =
		{
			props: {
				name: "domainId",
				placeholder: "Enter domainId",
				label: "domainId",
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

	private userNameconfig =
		{
			props: {
				name: "Username",
				placeholder: "Enter Username on new user",
				label: "Username",
			} as FormFieldProps,
			rules: {} as FormFieldRules
		} as IFormField;

	private emailconfig =
		{
			props: {
				name: "Email",
				placeholder: "Enter email address of new user",
				label: "Email address",
			} as FormFieldProps,
			rules: { required: true, email: true } as FormFieldRules
		} as IFormField;

	private passwordconfig =
		{
			props: {
				name: "password",
				placeholder: "Enter password for user",
				label: "Password",
			} as FormFieldProps,
			rules: { required: true, } as FormFieldRules
		} as IFormField;
	private connectionconfig =
		{
			props: { name: "connection", placeholder: "Choose connection", label: "Auth0 connection", required: true } as FormFieldProps,
			rules: { required: true } as FormFieldRules
		} as IFormField;
}
